import React, { useEffect, useState } from "react";
import { Navigate, useParams, Link } from "react-router-dom";
import MainLayout from "../../layouts/mainLayout";
import Tabs from "../../utils/tabs";
import VoyageFinalizationFuelAndWaterUsageComponent from "../../components/voyage/VoyageFinalizationFuelAndWaterUsageComponent";
import VoyageService from "../../services/voyageService";

export default function ConsumptionLogRecordsPage() {
  const params = useParams();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [voyage, setVoyage] = useState([]);

  useEffect(async () => {
    await init();
  }, []);

  const init = async () => {
    setLoading(true);
    let _voyage = await VoyageService.get(params.voyagePlanningId);
    setVoyage(_voyage || []);
    setLoading(false);
  };

  const tabHeaders = [{ icon: "icon ni ni-view-grid-wd", text: "Details" }];

  const tabContent = [
    <VoyageFinalizationFuelAndWaterUsageComponent voyageUnderView={voyage} />,
  ];

  const _tabView = (
    <Tabs headers={tabHeaders} contents={tabContent} contentPadding="3" />
  );

  const pageActions = (
    <div className="toggle-wrap nk-block-tools-toggle">
      <a
        href="#"
        className="btn btn-icon btn-trigger toggle-expand mr-n1"
        data-target="pageMenu"
      >
        <em className="icon ni ni-menu-alt-r" />
      </a>
      <div className="toggle-expand-content" data-content="pageMenu">
        <ul className="nk-block-tools g-3">
          <li>
            <Link to={`/voyages`} className="btn btn-white btn-outline-light">
              <em className="icon ni ni-arrow-left" />
              <span>Back to Voyages</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );

  return redirectUrl ? (
    <Navigate to={redirectUrl} replace={true} />
  ) : (
    <MainLayout
      title="Fuel & Water Consumption Log"
      loading={loading}
      showFullLoader={loading}
      pageActions={pageActions}
    >
      <div className="">{_tabView}</div>
    </MainLayout>
  );
}
